(function () {
	'use strict';

	angular
		.module('sempraWebapp')
		.controller('ListOrganizationController', listOrganizationController);

	/** @ngInject */
	function listOrganizationController(
		OrganizationViewModel,
		$scope,
		organizationActions,
		layoutActions
	) {
		var vm = this;
		var collapseIndexesArray = [];

		vm.organization = new OrganizationViewModel();
		vm.showOrganizationBelow = false;
		vm.organizationChecker = null;
		vm.selectedOrganizationId = null;

		init();

		vm.searchOrganization = function () {
			refresh();
		};

		vm.openMenu = function ($mdMenu, ev) {
			$mdMenu(ev);
		};

		vm.deleteSelectedOrganization = function(organization) {
			organizationActions.deleteOrganization(organization.id).then(function() {
				refresh();
			});
		}

		vm.expendOrganization = function(organization) {
			var index = collapseIndexesArray.indexOf(organization.id);
			if(collapseIndexesArray.indexOf(organization.id) === -1) {
				collapseIndexesArray.push(organization.id);
			} else {
				collapseIndexesArray.splice(index, 1);
			}
		}

		vm.showOrganization = function (organization) {
			return organization.id === 1 || collapseIndexesArray.includes(organization.id);
		}

		vm.setOrganizationTypeIconIcon = function (organizationType) {
			switch (organizationType) {
				case "REGION":
					return "language";
				case "SELF":
					return "perm_identity";
				case "COMPANY":
					return "domain";
				case "SITE":
					return "reorder";
				default:
					return "location_on";
			}
		}

		function refresh() {
			layoutActions.showLoader();
			organizationActions
				.getOrganizationsListByType()
				.then(function (orgRes) {
					vm.organization.refresh(orgRes);
					layoutActions.hideLoader();
				});
		}

		function init() {
			$scope.$on('$destroy', destroy);
			refresh();
		}

		function destroy() {
			vm.organization.destroy();
		}
	}
})();
